export default __webpack_public_path__ + "static/media/sign_decorate01.43ccd24e.png";